import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const AddDisplayDeviceSlicer = createSlice({
  name: 'AddDisplayDevice',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<any>,
  reducers: {
    addDisplayDevice: (state, _) => {
      state.isLoading = true;
    },
    successAddDisplayDevice: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddDisplayDevice: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddDisplayDeviceState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addDisplayDevice,
  successAddDisplayDevice,
  failureAddDisplayDevice,
  clearAddDisplayDeviceState,
} = AddDisplayDeviceSlicer.actions;

export default AddDisplayDeviceSlicer.reducer;
